<script setup>
import { watch, ref } from 'vue'
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
    required: false,
  },
  title: {
    type: String,
    default: '',
    required: false,
  },
  message: {
    type: String,
    default: '',
    required: false,
  },
  icon: {
    type: String,
    default: '',
    required: false,
  },
  status: {
    type: String,
    default: '',
    required: false,
  },
})

const emit = defineEmits(['update:open'])

const statusBgClasses = {
  success: 'bg-green-200/50 border border-green-500',
  error: 'bg-red-200/50 border border-red-500',
  warning: 'bg-yellow-200/50 border border-yellow-500',
  info: 'bg-blue-200/50 border border-blue-500',
}
const statusIconClasses = {
  success: 'text-green-500',
  error: 'text-red-500',
  warning: 'text-yellow-500',
  info: 'text-blue-500',
}

const isVisible = ref(false)

// Watch para activar el temporizador cuando 'open' cambie a true
watch(
  () => props.open,
  (newVal) => {
    if (newVal) {
      isVisible.value = true
      // Desaparece el toast después de 4 segundos
      setTimeout(() => {
        isVisible.value = false
        // Emite el evento para cerrar el toast
        emit('update:open', false)
      }, 4000)
    }
  }
)
</script>
<template>
  <transition
    name="slide-fade"
    @before-enter="isVisible = true"
    @after-leave="isVisible = false"
  >
    <div
      v-if="props.open"
      class="fixed top-[20px] right-[20px] max-w-xs w-full p-4 rounded-md shadow-lg flex items-center space-x-2"
      :class="statusBgClasses[props.status]"
    >
      <div v-if="props.icon" class="flex-shrink-0">
        <v-icon
          :name="props.icon"
          :class="statusIconClasses[props.status]"
        ></v-icon>
        <!-- Asume que estás usando Font Awesome o similar -->
      </div>
      <div class="w-full">
        <h4 class="text-md font-bold text-black">{{ props.title }}</h4>
        <p class="text-sm">{{ props.message }}</p>
      </div>
      <div>
        <button @click="$emit('update:open', false)">
          <v-icon name="io-close-circle-outline"></v-icon>
        </button>
      </div>
    </div>
  </transition>
</template>
<style scoped>
/* Transición para la animación de deslizamiento de derecha a izquierda */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-fade-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
